import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import SolutionDetail from "@/pages/SolutionDetail";

export const Route = createFileRoute("/en/industries/pharma-biotech/landing-in-europe/us-biotech")({
  head: () => buildRouteHead("/en/industries/pharma-biotech/landing-in-europe/us-biotech"),
  component: SolutionDetail,
});

